// extracted by mini-css-extract-plugin
module.exports = {"desc":"Sleep_desc__IwNfB","link":"Sleep_link__1ylkj"};